import PropTypes from 'prop-types';

export const socialLinkProps = {
  Icon: PropTypes.elementType.isRequired,
  title: PropTypes.string.isRequired,
};
